import type { NotesSettingsValue } from '@nesso/practice-contracts/practice-member-settings.models';

import type { SessionNoteSettings } from './session-note.types';

const lowercase = <T extends string>(value: T) => value.toLowerCase() as Lowercase<T>;

// practice-member-settings publishes its own casing; translating is the consumer's job.
export function toNoteSettings(notesSettings: NotesSettingsValue): SessionNoteSettings {
    return {
        format: lowercase(notesSettings.noteFormat),
        length: lowercase(notesSettings.noteLength),
        identifier: lowercase(notesSettings.identifier),
        includeCpt90837Justification: notesSettings.includeCpt90837Justification,
        includeDiagnosisCodes: notesSettings.includeDiagnosisCodes,
    };
}
